import React from 'react';
import { Box, Container, Typography } from '@mui/material';


const terms = {
    "TermsAndConditions": {
      "1. Introduction": {
        "1.1. Purpose": "These Terms and Conditions govern your use of the MindMapper AI mobile application, including its features, functionalities, and associated services.",
        "1.2. Acceptance": "By accessing or using MindMapper AI, you confirm that you have read, understood, and agree to be bound by these Terms and our Privacy Policy. If you do not agree, you must discontinue use of the app."
      },
      "2. User Accounts": {
        "2.1. Registration": "Users must sign up using a valid email address or Google Sign-In. By registering, you agree to provide accurate, complete, and current information. Misrepresentation may result in account suspension or termination.",
        "2.2. Account Security": "You are solely responsible for maintaining the confidentiality of your account credentials, including your password. Notify us immediately of any unauthorized use of your account.",
        "2.3. Termination": "We reserve the right to terminate or suspend your account at our sole discretion, with or without prior notice, for reasons including but not limited to violation of these Terms or suspected fraudulent activity."
      },
      "3. Use of the App": {
        "3.1. Functionality Overview": "MindMapper AI offers the following features: logging and interpreting dreams, viewing a dream diary, accessing preexisting meditations, and creating tailored meditations using an interactive wizard.",
        "3.2. User Obligations": "You agree to use the app for lawful purposes only. Prohibited activities include but are not limited to: engaging in malicious activities, distributing harmful software, attempting to breach app security, and using the app to harm others."
      },
      "4. Intellectual Property": {
        "4.1. Ownership": "The app, including all content, features, and functionality, is the exclusive property of MindMapper AI. This includes but is not limited to text, graphics, logos, and software, all of which are protected by intellectual property laws.",
        "4.2. Restrictions": "You are prohibited from modifying, distributing, reproducing, or creating derivative works based on the app without explicit written permission from MindMapper AI. Any unauthorized use may result in legal action."
      },
      "5. Content": {
        "5.1. User-Generated Content": "Users may create and save content such as dream logs and tailored meditations. You retain ownership of your submitted content but are solely responsible for its accuracy and legality.",
        "5.2. License to Use Content": "By submitting content, you grant MindMapper AI a worldwide, non-exclusive, royalty-free, transferable license to use, reproduce, display, and adapt your content for the purpose of providing and improving our services."
      },
      "6. Privacy": {
        "6.1. Data Collection": "Our Privacy Policy explains how we collect, use, and protect your data. By using the app, you consent to our data practices as described in the Privacy Policy.",
        "6.2. Data Protection": "We employ industry-standard measures to protect your data against unauthorized access, alteration, or destruction. However, we cannot guarantee absolute security. Users are advised to take precautions to secure their own data."
      },
      "7. Disclaimers": {
        "7.1. No Warranty": "MindMapper AI is provided 'as is' without warranties of any kind, whether express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.",
        "7.2. Limitation of Liability": "To the fullest extent permitted by law, MindMapper AI shall not be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in connection with your use of the app."
      },
      "8. Governing Law": {
        "8.1. Jurisdiction": "These Terms and Conditions are governed by and construed in accordance with the laws of Canada/Ontario. Users agree to submit to the exclusive jurisdiction of the courts located in Ontario for the resolution of any disputes."
      },
      "9. Changes to Terms": {
        "9.1. Updates": "We may revise these Terms from time to time. Any changes will be effective immediately upon posting in the app. Continued use of the app after such changes constitutes acceptance of the updated Terms.",
        "9.2. Notification": "For significant changes, we will provide notice via email or within the app. Users are encouraged to review the Terms periodically."
      },
      "10. Contact Information": {
        "10.1. Support": "For inquiries, feedback, or support, please contact us at help@mmai.live. We aim to respond to queries within 48 hours."
      }
    }
  }
  


  function DisplayTerms () {

    return (
        <Box sx={{ py: 5 }}>
            <Container maxWidth="md" sx={{ mb: 10 }}>
                <Typography variant="h4" align="center" gutterBottom>
                Terms and Conditions
                </Typography>
                <Typography variant="h6" align="center" gutterBottom>
                Last updated: Dec 17th 2024
                </Typography>
                {Object.keys(terms.TermsAndConditions).map((section, index) => (
                <Box key={index} sx={{ mt: 2 }}>
                    <Typography variant="h5" gutterBottom>
                    {section}
                    </Typography>
                    {Object.keys(terms.TermsAndConditions[section]).map((subSection, subIndex) => (
                    <Box key={subIndex} sx={{ mt: 1 }}>
                        <Typography variant="h6" gutterBottom>
                        {subSection}
                        </Typography>
                        <Typography>{terms.TermsAndConditions[section][subSection]}</Typography>
                    </Box>
                    ))}
                </Box>
                ))}
            </Container>
    
        </Box>
    
    )
    
    }
    
    export default DisplayTerms;